import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-calendar",
  "use": "icon-calendar-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol viewBox=\"0 0 20 20\" id=\"icon-calendar\">\n  <path d=\"M14 0h2v2h4v18H0V2h4V0h2v2h8V0zM2 18h16V8H2v10zM16 6h-2V4H6v2H4V4H2v3h16V4h-2v2zM6 12v-2h2v2H6zm6 4v-2h2v2h-2z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol